import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { fmtDate, fmtDateTime, priorityInfo } from "@/lib/format";
import { AlertRow } from "@/components/workspace/AlertRow";

export function LocationDetailCard({ recordId, onOpenIncident, close }) {
  const q = useQuery({ queryKey: ["location-detail", recordId], queryFn: async () => (await api.get(`/locations/${recordId}/detail`)).data });
  if (!q.data) return <div className="text-xs text-muted-foreground">Loading location record…</div>;
  const { record, alerts, history } = q.data;
  const active = alerts.filter((a) => a.state !== "inactive");
  const groups = ["officer_safety", "fire", "ems", "general"].map((c) => ({ c, items: active.filter((a) => a.category === c) })).filter((g) => g.items.length);
  return (
    <div className="space-y-3" data-testid="location-detail-card">
      <div>
        <div className="overline-label">Location record</div>
        <div className="display text-lg font-semibold">{record.common_name || record.raw}</div>
        <div className="text-xs text-muted-foreground">{record.raw} · <span className="mono">{record.canonical}</span>{record.aliases?.length ? ` · also: ${record.aliases.join(", ")}` : ""}</div>
        {record.notes && <div className="text-xs mt-1" data-testid="location-detail-notes">{record.notes}</div>}
      </div>
      <div>
        <div className="overline-label mb-1">Alerts & special instructions ({active.length})</div>
        {groups.length === 0 && <div className="text-xs text-muted-foreground">No active alerts for this location.</div>}
        <div className="space-y-1.5">{groups.map((g) => <div key={g.c} className="space-y-1">{g.items.map((a) => <AlertRow key={a.id} a={a} />)}</div>)}</div>
      </div>
      <div>
        <div className="overline-label mb-1">Incident history ({history.length})</div>
        <div className="max-h-[240px] overflow-auto rounded-md border">
          {history.length === 0 && <div className="p-2 text-xs text-muted-foreground">No prior incidents.</div>}
          {history.map((h) => (
            <button key={h.id} data-testid={`location-history-${h.incident_number}`} onClick={() => { onOpenIncident?.(h.id); }} className="w-full text-left flex items-center gap-2 px-2 py-1 border-b border-border/60 text-xs row-hover">
              <span className={`chip mono ${priorityInfo(h.priority).cls}`}>{priorityInfo(h.priority).short}</span>
              <span className="mono font-semibold">{h.incident_number}</span>
              <span className="mono text-muted-foreground" title={fmtDateTime(h.received_at)}>{fmtDate(h.received_at)}</span>
              <span className="font-medium truncate">{h.call_type_name}</span>
              <span className="ml-auto text-muted-foreground">{h.disposition_label || h.status.toUpperCase()}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
